<div
  appCustomTooltip
  (changeTooltipVisiblity)="changeTooltipVisiblity($event)"
  (hideDropdowns)="hideDropdowns($event)"
  class="sidebar"
  [class.sidebar-show]="!isSidebarHidden"
  role="navigation"
  aria-label="Main Navigation"
>
  <ng-container *ngFor="let sidebarItem of sidebarItems">
    <div class="item" [class.has-dropdown]="sidebarItem.dropDownItems.length">
      <a
        class="icon"
        [routerLink]="sidebarItem.routerLink"
        routerLinkActive="active"
        (click)="hideSidebar(sidebarItem)"
        role="menuitem"
        [attr.aria-haspopup]="sidebarItem.dropDownItems.length > 0 ? 'true' : 'false'"
        [attr.aria-expanded]="sidebarItem.showDropdown ? 'true' : 'false'"
      >
        <span class="icon-inactive">
          <img [src]="sidebarItem.inactiveLink" alt="inactive-link" />
        </span>
        <span class="icon-active">
          <img [src]="sidebarItem.activeLink" alt="active-link" />
        </span>
        <span class="link-name">{{ sidebarItem.title | translate }}</span>
        <span class="left-border"></span>
        <span
          class="drop-down-icon"
          [class.rotate-icon]="sidebarItem.showDropdown"
          (click)="toggleDropdown(sidebarItem)"
        >
          <img src="./assets/icons/arr-dn.svg" alt="arrow-down" />
        </span>
      </a>
      <span *ngIf="!isTooltipDisabled" class="tooltip" role="status">{{ sidebarItem.title | translate }}</span>
      <div
        class="drop-down-menu"
        [ngStyle]="sidebarItem.showDropdown && { height: sidebarItem.dropDownItems.length * 3 + 'rem' }"
        role="menu"
        *ngIf="sidebarItem.dropDownItems.length > 0"
      >
        <ng-container *ngFor="let menuItem of sidebarItem.dropDownItems">
          <a class="drop-down-menu-item" rel="noopener" role="menuitem">{{ menuItem.title }}</a>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="!isSidebarHidden" (click)="hideSidebar(null)" class="sidebar-backdrop" role="presentation"></div>
<div *ngIf="!isSidebarHidden" class="close-icon" (click)="hideSidebar(null)" role="button" aria-label="Close Sidebar">
  <img src="./assets/icons/close.svg" alt="close-icon">
</div>
